import Client from '../axios-client';

const resource = '/invitation/questionnaires';

export default {
  getQuestionnaire(questionnaireId) {
    return Client.get(`${resource}/${questionnaireId}`);
  },
  downloadAttachment(questionnaireId, base64 = true) {
    const config = base64
      ? {} // JSON
      : { responseType: 'blob' }; // binarnie
    return Client.get(`${resource}/${questionnaireId}/download?base64=${base64}`, config)
  },
};
